// Version : 0.0.1
// Author : AGALYA

const ActiveMemberActionTypes = {
	/******************* GET ACTIVE MEMBER LIST START ******************************** */
	GET_ACTIVE_MEMBER_LIST_START: 'get_active_member_start',
	GET_ACTIVE_MEMBER_LIST_SUCCESS: 'get_active_member_success',
	GET_ACTIVE_MEMBER_LIST_FAILURE: 'get_active_member_failure',
	GET_ACTIVE_MEMBER_LIST_RESPONSE_RESET: 'get_active_member_response_reset',
	GET_ACTIVE_MEMBER_LIST_RESPONSE_CHANGED: 'get_active_member_response_changed',
	/******************* GET ACTIVE MEMBER LIST END ******************************** */
};
export default ActiveMemberActionTypes;
